import { Badge, Box, Flex, Text } from '@frontend/components';

const LabelWithBadge = ({ labelText }) => (
  <Flex justify="space-between">
    <Box>
      <Text>{labelText}</Text>
    </Box>
    <Box>
      <Badge colorScheme="info" size="sm">
        CSR
      </Badge>
    </Box>
  </Flex>
);

const Label = ({ userGroup }) => {
  const { businessName, locator, hasCsr } = userGroup;
  const labelText = `${businessName} (${locator})`;

  if (hasCsr) return <LabelWithBadge labelText={labelText} />;
  return <Text>{labelText}</Text>;
};
export default Label;
